import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { EASE } from "../motion";
import { useLang, LANGS } from "../../lib/i18n";

export const Navbar = () => {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#soins", label: t("nav.soins") },
    { href: "#machine", label: t("nav.machine") },
    { href: "#resultats", label: t("nav.resultats") },
    { href: "#tarifs", label: t("nav.tarifs") },
    { href: "#rendez-vous", label: t("nav.dispos") },
    { href: "#contact", label: t("nav.contact") },
  ];

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-white/70 backdrop-blur-xl border-b border-taupe/20 shadow-sm" : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-4">
        <a href="#top" data-testid="navbar-logo" className="flex items-center shrink-0">
          <img src="/logo.png" alt="Nadou Skin" className="h-12 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-[12px] tracking-[0.14em] uppercase text-espresso/70 hover:text-espresso transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3 shrink-0">
          <div className="flex items-center gap-1 border border-taupe/30 rounded-full px-1.5 py-1" data-testid="lang-switcher">
            {LANGS.map((l) => (
              <button
                key={l.code}
                data-testid={`lang-${l.code}`}
                onClick={() => setLang(l.code)}
                className={`text-[11px] tracking-[0.08em] px-2.5 py-1 rounded-full transition-colors duration-300 ${
                  lang === l.code ? "bg-espresso text-cream" : "text-espresso/55 hover:text-espresso"
                }`}
              >
                {l.label}
              </button>
            ))}
          </div>
          <a
            href="#rendez-vous"
            data-testid="nav-booking-btn"
            className="rounded-full bg-espresso text-cream text-[12px] tracking-[0.12em] uppercase px-5 py-3 hover:bg-taupe hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            {t("nav.reserver")}
          </a>
        </div>
      </div>
    </motion.header>
  );
};
